import { IsNotEmpty, IsUUID } from 'class-validator';
import { GAEventPlatform, GAEventTypes } from '../../enums';
import type { DateOrString } from '../../utils/types';

export class KeyValueParam {
	public key: string;
	public string_value: string;
	public number_value: number;
}

export class GAEventMetaDto {
	event_params: KeyValueParam[];
}

export class AggregatedStatsFromGA {
	eventName: GAEventTypes;
	platform: GAEventPlatform;
	eventCount: number;
	lastTimestamp: Date;
}

// for event_page_view event type
export class TrackEventInstanceDto {
	@IsNotEmpty({ message: 'Base event id filter is required' })
	@IsUUID()
	public baseId: string;

	@IsNotEmpty({ message: 'Instance filter is required' })
	public instance: DateOrString;

	@IsNotEmpty({ message: 'Author id filter is required' })
	@IsUUID()
	public authorId: string;
}

export class GADeviceInfoMeta {
	category: string | null;
	mobile_brand_name: string | null;
	mobile_model_name: string | null;
	mobile_marketing_name: string | null;
	mobile_os_hardware_model: string | null;
	operating_system: string | null;
	operating_system_version: string | null;
	vendor_id: string | null;
	advertising_id: string | null;
	langauge: string | null;
	is_limited_ad_tracking: boolean | null;
	timezone_offset_seconds: number | null;
	browser: string | null;
	browser_version: string | null;
	web_info: {
		browser: string | null;
		browser_version: string | null;
		hostname: string | null;
	} | null;
}

export class GACollectedTraficSourceMeta {
	manual_campaign_id: string | null;
	manual_campaign_name: string | null;
	manual_source: string | null;
	manual_medium: string | null;
	manual_term: string | null;
	manual_content: string | null;
	manual_source_platform: string | null;
	manual_creative_format: string | null;
	manual_marketing_tactic: string | null;
	gclid: string | null;
	dclid: string | null;
	srsltid: string | null;
}
